import React, { useState, useRef } from "react";
import { Button } from "@mui/material";
import ModalDialog from "../ModalDialog/ModalDialog"; // existing styled modal
import styles from "./ReLogin.module.scss";
import usernameImg from "../../assets/images/Username.png";
import passwordImg from "../../assets/images/Password.png";
import { useDispatch } from 'react-redux';
import { GROUPLEADERCRED } from "../../redux/actionTypes"
import { encryptStationPassword } from '../../utils/EncryptionUtils'; 

export const GroupLeaderLoginAction = (username, password) => {
  return {
    type: GROUPLEADERCRED,
    username,
    password,
  };
};
const ReLogin = ({ open,handleReLogin, handleClose, isDark = false }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  // Characters you want to prevent in input

 const onSubmit = (e) => {
  e.preventDefault();
    const encryptedPassword = encryptStationPassword(password);
  handleReLogin(e, username, encryptedPassword);
  dispatch(GroupLeaderLoginAction(username, password))
};
  return (
    <ModalDialog
      open={open}
      title=""
      modalWidth="40%"
      modalHeight="auto"
      onClose={handleClose}
    > 
      <form onSubmit={(e)=>onSubmit(e)} className={styles.reloginContainer}>
        <h1 >Login</h1>
  <div className={`${styles.inputWrapper} ${isDark ? styles.darkInput : ""}`}>
    <div className={styles.inputField}>
      <img src={usernameImg} alt="user" className={styles.inputIcon} />
      <input
        type="text"
        placeholder="User Name"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
    </div>
  </div>

  <div className={`${styles.inputWrapper} ${isDark ? styles.darkInput : ""}`}>
    <div className={styles.inputField}>
      <img src={passwordImg} alt="lock" className={styles.inputIcon} />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </div>
  </div>

  <button type="submit" className={styles.loginButton}>
    Login
  </button>
</form>

    </ModalDialog>
  );
};

export default ReLogin;
